export default __webpack_public_path__ + "static/media/scratch-surface.8971a5d3.jpg";